import { StrictMode } from 'react';

import { Capacitor } from '@capacitor/core';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import App from './App.tsx';
import './i18n.ts';

// Add capacitor class to body for CSS targeting
if (Capacitor.isNativePlatform()) {
  document.body.classList.add('capacitor');
}

// Initialize Sentry by default, but disable in development
if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: 'https://d19a117f73e1e6f3d609e9bfad1981e1@o4507389874601984.ingest.us.sentry.io/4509503897272320',
    sendDefaultPii: true,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    profilesSampleRate: 1.0,
    tracesSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[400, 599]],
      }),
      Sentry.replayIntegration(),
      Sentry.replayCanvasIntegration(),
      Sentry.extraErrorDataIntegration(),
      Sentry.captureConsoleIntegration(),
    ],
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
